class ResponsiveTools {
    constructor() {
        this.responsive_modal = document.querySelector('[data-responsive-tools]');
        this.window_width = window.innerWidth;
        this.breakpoints = {
            'tiny': 320,
            'xs': 768,
            'sm': 992,
            'md': 1024,
            'lg': 1280,
            'xl': 1366,
            '2xl': 1536,
            '3xl': 1680,
            '4xl': 1920,
        };
        this.current_breakpoint_name = null;
        this.current_breakpoint_min = null;
        this.next_breakpoint_min = null;
        this.breakpoints_list_wrapper = false;
        this.proportion_calc = false;
        this.proportion_sizes = [];
    }

    init() {
        if (!this.responsive_modal) {
            return false;
        }

        this.breakpoints_list_wrapper = this.responsive_modal.querySelector('[data-sizes-list]');
        this.checkBreakpoint();
        this.showSizesList();

        window.addEventListener('resize', () => {
            this.checkBreakpoint();
            this.showSizesList();
        });


        document.querySelector('input#base_value').addEventListener('change', (e) => {
            e.preventDefault();
            console.log('change');
            this.proportion_calc = parseInt(document.querySelector('input#base_value').value);
            this.calcProportion();
        })
    }

    calcProportion() {
        if(!this.proportion_calc) {
            this.proportion_sizes = [];
            this.showSizesList();
        }


        const result = (this.proportion_calc / 1920);


        for (let key in this.breakpoints) {
            const value = this.breakpoints[key];
            const result_for_breakpoint = Math.round(value * result);
            this.proportion_sizes[key] = result_for_breakpoint;
        }

        this.showSizesList();
    }


    showSizesList() {
        this.breakpoints_list_wrapper.innerHTML = '';
        const list = document.createDocumentFragment();
        for (let key in this.breakpoints) {
            let size = document.createElement('li');
            if(this.current_breakpoint_name === key) {
                size.style.cssText = 'padding: 0 16px;margin-bottom: 5px; background-color: #ff000040; border-top: 1px solid red; border-bottom: 1px solid red;';
            } else {
                size.style.cssText = 'padding: 0 16px;margin-bottom: 5px;';
            }
            let html= '<span style="font-weight: bold;">'+ key +'</span> : <span>min-width: <span style="color: orange;">'+this.breakpoints[key]+'px</span></span>';
            if(this.proportion_sizes[key]) {
                html += '<span style="color: yellow; background-color: blue; padding: 2px; margin-left: 4px;"> '+this.proportion_sizes[key]+'&nbsp;|&nbsp;' + this.proportion_sizes[key]/16 + ' rem</span>';
            }

            size.innerHTML = html;
            list.appendChild(size);
        }


        let vw = (this.proportion_calc / 1920) * 100;
        let vh = (this.proportion_calc / 900) * 100;

        let vw_html = document.createElement('p');
        vw_html.style.cssText = 'text-align:center; font-size: 10px; margin: 4px 0;';

        let vh_html = document.createElement('p');
        vh_html.style.cssText = 'text-align:center; font-size: 10px; margin: 4px 0;';

        vw_html.innerText = vw.toFixed(2) +' vw dla ekranu o szerokości 1920';
        vh_html.innerText = vh.toFixed(2) +' vh dla ekranu o wysokości 900';


        this.breakpoints_list_wrapper.appendChild(list);
        this.breakpoints_list_wrapper.appendChild(vw_html);
        this.breakpoints_list_wrapper.appendChild(vh_html);
    }

    checkBreakpoint() {
        this.window_width = window.innerWidth;
        let last_key = false;
        let key;
        for (key in this.breakpoints) {
            if (this.breakpoints.hasOwnProperty(key)) {
                if (this.breakpoints[key] > this.window_width) {
                    console.log(this.breakpoints[key]);
                    console.log(this.window_width);
                    this.current_breakpoint_min = this.breakpoints[last_key];
                    this.current_breakpoint_name = last_key;
                    this.next_breakpoint_min = this.breakpoints[key];
                    break;
                }
                else if(this.breakpoints[key] == this.window_width) {
                    this.current_breakpoint_min = this.breakpoints[key];
                    this.current_breakpoint_name = key;
                    this.next_breakpoint_min = this.breakpoints[key];
                    break;
                }
                last_key = key;
            }
        }

        const max_value = this.breakpoints[key];
        if (max_value <= this.window_width && max_value === 1920) {
            this.current_breakpoint_min = this.breakpoints[key];
            this.current_breakpoint_name = key;
            this.next_breakpoint_min = false;
        }

        this.updateValues();

    }

    updateValues() {
        this.responsive_modal.querySelector('#window-width').innerHTML = this.window_width + 'px';
        // this.responsive_modal.querySelector('#breakpoint-name').innerHTML = this.current_breakpoint_name;
        // this.responsive_modal.querySelector('#breakpoint-min').innerHTML = this.current_breakpoint_min + 'px';
        // this.responsive_modal.querySelector('#breakpoint-max').innerHTML = (this.next_breakpoint_min) ? this.next_breakpoint_min + 'px' : 'unlimited';
    }

}

const responsive = new ResponsiveTools();
responsive.init();
